// Spaced review — "Master Your Misses".
// Server: student-agent-api/routers/micro_learning.py (/past-exams/review/*).
// Distinct from examRunwayAPI's ReviewQuestion (that's post-session answer review).

import api from './api';
import type { MediaItem } from '../components/MicroLearning/MediaDisplay';

export interface ReviewSubjectDue {
  subject: string;
  due_count: number;
}

export interface ReviewSummary {
  success: boolean;
  total_due: number;
  by_subject: ReviewSubjectDue[];
  fixed_today: number;
  daily_target: number;
  mistakes_mastered: number;
}

// Short subject names so the compact review bar fits more chips per row.
const SUBJECT_SHORT: Record<string, string> = {
  Mathematics: 'Math',
  Geography: 'Geo',
  Economics: 'Econ',
  Aptitude: 'Apt',
  History: 'Hist',
  English: 'Eng',
  Biology: 'Bio',
  Chemistry: 'Chem',
  Physics: 'Phys',
  Civics: 'Civ',
};
export const shortSubject = (s: string): string => SUBJECT_SHORT[s] || s;

export interface MissesQuestion {
  question_id: string;
  question_text: string;
  has_media?: boolean;
  media?: MediaItem[];
  options: Array<{ label: string; text: string; is_correct?: boolean | null }>;
  metadata: {
    topic?: string;
    correct_answer: string;
    explanation?: string;
  };
  is_review?: boolean;
}

export interface MissesSession {
  success: boolean;
  subject: string;
  questions: MissesQuestion[];
  due_remaining: number;
}

export const reviewAPI = {
  // Per-subject due counts for the "Master Your Misses" card. Returns
  // total_due:0 when the flag is off, so the card simply hides.
  summary: async (): Promise<ReviewSummary> => {
    const r = await api.get('/past-exams/review/summary');
    return r.data;
  },
  // A review-only set of a subject's most-overdue misses.
  session: async (subject: string, limit = 10): Promise<MissesSession> => {
    const r = await api.get('/past-exams/review/session', {
      params: { subject, limit },
    });
    return r.data;
  },
  // Quiet "Mistakes mastered" profile stat.
  stats: async (): Promise<{ success: boolean; mistakes_mastered: number }> => {
    const r = await api.get('/past-exams/review/stats');
    return r.data;
  },
};
